import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { createHead } from '@unhead/vue/client'
import { configure } from 'vue-gtag'
import './index.css'
import App from './App.vue'
import router from './router'
import EchoService from '@/services/EchoService'
import { initSentry } from '@/lib/sentry'
import { reloadOnceForChunkError } from '@/utils/chunkReload'

// Vite fires this when a preloaded chunk fails to load (typically after a new
// deploy replaced the hashed assets this tab was built against). Recover with a
// single guarded reload.
window.addEventListener('vite:preloadError', (event) => {
  reloadOnceForChunkError((event as any).payload)
})

EchoService.init()
import { Toaster } from 'vue-sonner'
import 'vue-sonner/style.css'

const app = createApp(App)
const pinia = createPinia()
const head = createHead()

// Initialize Sentry before other plugins
initSentry({ app, router })

app.use(pinia)
app.use(router)
app.use(head)

// Configure Google Analytics
if (import.meta.env.VITE_GA_MEASUREMENT_ID) {
  configure({
    tagId: import.meta.env.VITE_GA_MEASUREMENT_ID,
    config: {
      send_page_view: false
    }
  })
}

app.component('Toaster', Toaster)
app.mount('#app')
